import React from 'react';
import {
  WalletProvider as UseWalletProvider,
  WalletManager,
  NetworkId,
  WalletId
} from '@txnlab/use-wallet-react';

// Create manager instance
const manager = new WalletManager({
  wallets: [
    WalletId.PERA,
    WalletId.EXODUS,
    WalletId.KIBISIS,
    WalletId.LUTE,
    WalletId.DEFLY
  ],
  defaultNetwork: NetworkId.MAINNET
});

export const WalletProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <UseWalletProvider manager={manager}>
      {children}
    </UseWalletProvider>
  );
};
